<style scoped lang="less">
.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;

	.sclectlable {
		margin-right: 20px;
	}
}

.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	display: flex;
	align-items: center;
	background-color: #f7f7f7;
	
	

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}
	
	
	button {
		background-color: #0a68e3;
		border: none;
		margin: 0 20px;
	}
	// button:last-child {
	// 	background-color: #ff8300;
	// }

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.tabslis {
	button {
		color: #fff;
	}

	/deep/ th {
		text-align: center;
	}

	/deep/ td {
		text-align: center;
	}

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		background-color: #f41127;
	}
}

.qutionitem {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 20px 0;
	.qutionits {
		margin-right: 20px;
	}
}
</style>
<template>
	<div>
		
		<div class="resourbtn">
			<el-button @click="addqutions()" type="primary" size="small" icon="fa fa-plus">添加所选题目</el-button>
			<div>
				<el-select v-model="pagesobj.SQT_GUID" clearable placeholder="请选择试题类型">
					<el-option v-for="item in testtypelist" :key="item.SQT_GUID" :label="item.SQT_Name" :value="item.SQT_GUID"></el-option>
				</el-select>
			</div>
			<div class="primarybtn" @click="getresours()"><el-button type="primary" icon="el-icon-search">搜索</el-button></div>
			
			<!-- <div class="manageselect">
				<div class="sclectlable">
					<div>
						<el-select v-model="pagesobj.SQT_GUID" clearable placeholder="请选择试题类型">
							<el-option v-for="item in testtypelist" :key="item.SQT_GUID" :label="item.SQT_Name" :value="item.SQT_GUID"></el-option>
						</el-select>
					</div>
				</div>
			
				<div class="primarybtn" @click="getresours()"><el-button type="primary" icon="el-icon-search">搜索</el-button></div>
			</div> -->
			<!-- <el-button @click="addtimu()" type="primary" size="small" icon="fa fa-plus">添加题型</el-button>
			<el-button @click="addtimulist()" type="primary" size="small" icon="fa fa-plus">批量导入</el-button> -->
		</div>
		<div class="tables">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize()" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="pagesobj.pageSize" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table
							:data="tableData"
							ref="childtable"
							@select="selectionchange"
							@select-all="handleSelectAll"
							header-row-class-name="tablestitle"
							border
							style="width: 100%"
						>
							<el-table-column type="selection" width="55"></el-table-column>
							<el-table-column label="题目内容" prop="SQB_Question"></el-table-column>
							<el-table-column label="试题类型" prop="SQT_Name" width="100"></el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ pagesobj.pageSize }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="pagesobj.pageSize"
							:total="totalall"
							:current-page="pagesobj.pageIndex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

import {
	getGetQuetype,
	GetQuestionList,
	GetTrainingStrategyList,
	getGetProfList,
	getPositionList,
	changeGradeGet,
	getGetResourceTypes,
	QuestionAdd,
	DeleteQuestion,
	QuestionDetails,
	UpdateQuestion,
	ImportQuestion
} from '@/request/api/homesview/yunhomes/yunhom.js';

export default {
	props: {
		caguid: String,
		prguid: String,
		ilguid: String,
		chiHeadactive: Number,
		chiHeadactivechilidx: Number,
		list: Array,
		chocesname: String
	},
	data() {
		return {
			dialogVisibles: false,
			dialogVisible: false,
			// 标题
			paths: [
				{
					path: '/homesview/testists/questionbank',
					name: '题库管理'
				}
			],
			totalall: 0,
			fileList: [],
			// 专业筛选项列表
			options: [],
			value: '',
			input: '',
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				sm_title: '',
				smt_guid: '',
				PR_GUID: '',
				PCR_RuleTitle: '',
				IL_GUID: '',
				pro_guid: '',
				PCT_IsState: '',
				SKY_GUID: '',
				SQB_IsDispark: '',
				SQT_GUID: '',
				StartTime: '',
				EndTime: '',
				SKY_GUID: ''
			},
			tabsnun: 1,
			tableData: [],
			choicetableData: [],
			// 获取专业、岗位、资源类型列表
			rtlist: [],
			prolist: [],
			polist: [],
			rtlist: [],
			gradeget: [],
			quesvalue: '',
			// 知识类别  试题类型
			knowledge: [],
			testtypelist: [],
			// 表单
			ruleForm: {
				CA_GUID: '',
				PR_GUID: '',
				SKY_GUID: '',
				IL_GUID: '',
				SQB_IsDispark: 1,
				SQB_Question: '',
				SQO_OptionName: '',
				option: [],
				typeotion: 1,
				SQB_AnswerAnalysis: '',
				SQT_GUID: '',
				btns: ''
			},
			ruleFormcopy: {},
			rules: {
				SKY_GUID: [{ required: true, message: '请输入知识专业', trigger: 'blur' }],
				PR_GUID: [{ required: true, message: '请选择岗位', trigger: 'change' }],
				IL_GUID: [{ required: true, message: '请选择等级', trigger: 'change' }],
				CA_GUID: [{ required: true, message: '请选择专业', trigger: 'change' }],
				SQB_Question: [{ required: true, message: '请输入试题内容', trigger: 'blur' }],
				SQB_AnswerAnalysis: [{ required: true, message: '请输入答案解析', trigger: 'blur' }],
				SQT_GUID: [{ required: true, message: '请输入试题类型', trigger: 'change' }]
			},
			isrelenum: 6,
			istypeotionces: '',
			setlistsvable: false
		};
	},
	watch: {
		list(oldvar, newvar) {
			// console.log(oldvar, newvar, '获取list');
		}
	},
	mounted() {
		this.ruleFormcopy = JSON.parse(JSON.stringify(this.ruleForm));
		this.pagesobj.pro_guid = this.caguid;
		this.pagesobj.PR_GUID = this.prguid;
		this.pagesobj.IL_GUID = this.ilguid;
		this.choicetableData = this.list;
		// console.log(this.choicetableData, '获取', this.list);
		this.get();
	},
	updated() {
		// console.log(this.list,"关闭")
	},
	computed: {},
	methods: {
		// 题目添加
		addqutions() {
			// console.log(this.chiHeadactive, this.choicetableData);
			let qutionsobj = {
				HE_HeadingsText: '章节课后作业',
				HE_SortNumber: 0,
				HE_IsJob: true,
				sqblist: []
			};
			if (this.choicetableData.length == 0) {
				this.$message('请选择题目');
				return;
			}

			qutionsobj.HE_SortNumber = this.chiHeadactive;
			qutionsobj.sqblist = this.choicetableData;

			// console.log(qutionsobj, '编辑作业1111', this.chocesname);

			if(this.chocesname == "编辑作业"){
				// console.log(qutionsobj,"编辑作业")
				qutionsobj.HE_SortNumber = this.chiHeadactivechilidx
				this.$emit('custom-eventedit', JSON.stringify(qutionsobj));
			}else{
				this.$emit('custom-event', JSON.stringify(qutionsobj));
			}
		},

		// 选择
		selectionchange(list, row) {
			if (this.choicetableData.find(item => item.SQB_GUID == row.SQB_GUID)) {
				//下面这个filter方法就是删除的方法
				this.choicetableData = this.choicetableData.filter(item => item.SQB_GUID != row.SQB_GUID);
			} else {
				this.choicetableData.push(row);
			}

			// console.log(this.choicetableData)
		},
		// 全选
		//该方法是当页全选的方法
		handleSelectAll(rows) {
			if (rows.length) {
				rows.forEach(row => {
					if (!this.choicetableData.find(item => item.SQB_GUID == row.SQB_GUID)) {
						this.choicetableData.push(row);
					}
				});
			} else {
				this.tableData.forEach(row => {
					this.choicetableData = this.choicetableData.filter(item => item.SQB_GUID != row.SQB_GUID);
				});
			}
		},
		// 提交修改
		// 表单
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					if (this.ruleForm.SQT_GUID == '') {
						this.$message('请选择题目');
						return;
					}
					if (!this.ruleForm.option.some(itm => itm.SQO_IsAnswer)) {
						this.$message('请选择题目答案');
						return;
					}

					QuestionAdd(this.ruleForm).then(res => {
						if (res.data.code > 0) {
							this.$message.success(res.data.msg);
							this.dialogVisible = false;
							this.getresours();
						}
					});
				} else {
					return false;
				}
			});
		},
		editsForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					if (this.ruleForm.SQT_GUID == '') {
						this.$message('请选择题目');
						return;
					}
					if (!this.ruleForm.option.some(itm => itm.SQO_IsAnswer)) {
						this.$message('请选择题目答案');
						return;
					}

					UpdateQuestion(this.ruleForm).then(res => {
						if (res.data.code > 0) {
							this.$message.success(res.data.msg);
							this.dialogVisibles = false;
							this.getresours();
						}
					});
				} else {
					return false;
				}
			});
		},
		submitFormdr(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					if (this.ruleForm.SQT_GUID == '') {
						this.$message('请选择题目');
						return;
					}
					if (this.fileList.length == 0) {
						this.$message('请上传对应的题目模板');
						return;
					}

					// console.log(this.fileList,"图片列表")
					var formData = new FormData();
					formData.append('pro_guid', this.ruleForm.CA_GUID);
					formData.append('PR_GUID', this.ruleForm.PR_GUID);
					formData.append('SKY_GUID', this.ruleForm.SKY_GUID);
					formData.append('IL_GUID', this.ruleForm.IL_GUID);
					formData.append('SQB_IsDispark', this.ruleForm.SQB_IsDispark);
					formData.append('SQT_GUID', this.ruleForm.SQT_GUID);
					formData.append('filedata', this.fileList[0].raw);

					ImportQuestion(formData).then(res => {
						if (res.data.code > 0) {
							this.$message.success(res.data.msg);
							this.setlistsvable = false;
							this.ruleForm = this.ruleFormcopy;

							this.getresours();
						}
					});
				} else {
					return false;
				}
			});
		},
		beforechangefilezy() {
			// 上传之前
		},
		// 上次表格
		handleChange(file, fileList) {
			this.fileList = fileList;
		},
		addtimulist() {
			// console.log('批量导入');
			this.setlistsvable = true;
			this.fileList = [];
		},
		doloads(fliename) {
			window.location.href = 'https://www.hngtsd.net:65535/Template/' + fliename + '.xls';
		},
		addtimu() {
			// console.log(this.ruleFormcopy);
			this.dialogVisible = true;
			this.ruleForm = this.ruleFormcopy;
		},
		resetForm(formName) {
			this.ruleForm = {};
			// 重置
			this.$refs[formName].resetFields();
		},
		changequionitm() {
			// ruleForm.SQO_OptionName
			if (this.ruleForm.SQO_OptionName == '') {
				this.$message('请输入答案');
				return;
			}
			if (this.ruleForm.option.length >= this.isrelenum) {
				this.$message('添加答案过长');
				return;
			}
			if (this.ruleForm.SQB_Question == '') {
				this.$message('请输入题目');
				return;
			}
			let option = {
				SQO_OptionName: this.ruleForm.SQO_OptionName,
				SQO_IsAnswer: false
			};

			this.ruleForm.option.push(option);
			// console.log(this.ruleForm.option.some(itm => itm.SQO_IsAnswer))
			if (!this.ruleForm.option.some(itm => itm.SQO_IsAnswer)) {
				this.ruleForm.option[0].SQO_IsAnswer = true;
			}

			this.ruleForm.SQO_OptionName = '';
		},
		deleteoption(itm) {
			let ruleobj = JSON.parse(JSON.stringify(this.ruleForm));
			ruleobj.option.splice(ruleobj.option.indexOf(itm), 1);

			this.ruleForm = ruleobj;
			// console.log(this.ruleForm.option)
		},
		changeanswer(idx) {
			if (this.istypeotionces != '4EBE5A8F10644FBF8FE61151567F90A3') {
				this.ruleForm.option.forEach(itm => (itm.SQO_IsAnswer = false));
				this.ruleForm.option[idx].SQO_IsAnswer = true;
			} else {
				this.ruleForm.option[idx].SQO_IsAnswer = !this.ruleForm.option[idx].SQO_IsAnswer;
			}
		},
		changeradios(e) {
			// console.log(e,this.ruleForm.typeotion)
			// if(e==3){}
			// console.log(e,"id")
			if (this.ruleForm.option.length > 0) {
				this.$confirm('当前题目未添加, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						this.istypeotionces = e;
						this.ruleForm.option = [];
						if (e == 'BCDC7963A8A34C5788501CFCDE87487D') {
							this.isrelenum = 2;
						} else {
							this.isrelenum = 6;
						}
						this.ruleForm.SQO_OptionName = '';
						this.ruleForm.SQB_Question = '';
					})
					.catch(() => {
						this.ruleForm.typeotion = this.istypeotionces;
					});
			} else {
				if (e == 'BCDC7963A8A34C5788501CFCDE87487D') {
					this.isrelenum = 2;
				} else {
					this.isrelenum = 6;
				}
				this.ruleForm.SQO_OptionName = '';
				this.ruleForm.SQB_Question = '';
				this.istypeotionces = e;
			}
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		// 试题类型
		getquestype() {
			getGetQuetype().then(res => {
				// console.log(res,"获取试题类型")
				this.testtypelist = res.data.data;
			});
		},

		getprolist() {
			getGetProfList().then(res => {
				// console.log(res.data.data)
				if (res.data.code > 0) {
					this.prolist = res.data.data;
					if (this.pagesobj.pro_guid !== '') {
						this.getpolist();
					}
				}
			});
		},
		getpolist() {
			getPositionList(this.pagesobj.pro_guid).then(res => {
				if (res.data.code > 0) {
					this.polist = res.data.data;
				}
			});
		},
		editszy(itm) {
			// 点击编辑 获取详情
			// console.log("点击编辑")
			let source = {
				SQB_GUID: itm.SQB_GUID
			};
			QuestionDetails(source).then(res => {
				// console.log(res);
				this.dialogVisibles = true;
				this.ruleForm = JSON.parse(JSON.stringify(res.data.data));
				this.ruleForm.option = res.data.data.Questionoptions;
				if (this.ruleForm.SQT_GUID == 'BCDC7963A8A34C5788501CFCDE87487D') {
					this.isrelenum = 2;
				} else {
					this.isrelenum = 6;
				}
				// console.log(res.data.data);
				this.getpolist();
				if (this.ruleForm.SQB_IsDispark) {
					this.ruleForm.SQB_IsDispark = 1;
				} else {
					this.ruleForm.SQB_IsDispark = 0;
				}
			});
		},
		deleteresce(re) {
			let review = {
				SQB_GUID: re.SQB_GUID
			};
			DeleteQuestion(review).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
					this.get();
				}
			});
		},
		changesqx(e) {
			if (e == 0) {
				return '全网公开（所有登录用户）';
			} else if (e == 1) {
				return '只对本院校公开';
			} else if (e == 2) {
				return '全网公开（游客、非注册用户）';
			} else {
				return '私有';
			}
		},
		indexMethod(index) {
			return index + 1;
		},
		changecurr(val) {
			this.pagesobj.pageIndex = val;
			this.getresours();
		},
		get() {
			this.getquestype();
			this.getresours();
		},
		// 改变
		changetablesize() {
			this.getresours();
		},
		getgrads() {
			changeGradeGet().then(res => {
				// console.log("获取等级",res)
				this.gradeget = res.data.data;
			});
		},

		getResourceType() {
			getGetResourceTypes().then(res => {
				if (res.data.code > 0) {
					this.rtlist = res.data.data;
				}
			});
		},
		getresours() {
			// console.log(this.quesvalue)
			this.pagesobj.StartTime = this.quesvalue[0];
			this.pagesobj.EndTime = this.quesvalue[1];

			GetQuestionList(this.pagesobj).then(res => {
				if (res.data.code > 0) {
					// console.log(res)
					this.tableData = res.data.data.list;
					this.totalall = res.data.data.totalCount;

					if (this.choicetableData.length > 0) {
						this.$nextTick(() => {
							this.tableData.forEach((item, index) => {
								if (this.choicetableData.findIndex(v => v.SQB_GUID == item.SQB_GUID) >= 0) {
									// console.log('获取', this.$refs.childtable);
									this.$refs.childtable.toggleRowSelection(item, true);
								}
							});
						});
					}
				}
			});
		}
	},
	components: {
	
	}
};
</script>
